module.exports = require("cli-spinners");


//////////////////
// WEBPACK FOOTER
// external "cli-spinners"
// module id = 54
// module chunks = 0